<mat-sidenav-container class="h-100">
  <div class="login-outer-flex h-100">
    <div class="login-inner-flex h-100">
      <form class="mat-elevation-z6">
        <div class="login-header bg-primary login-header-flex" [class.bg-image]="true">
          <img class="login-logo" [src]="getLogo" alt="logo" />
          <div class="title px-3 login-title-flex">{{ getLoginTitle }}</div>
        </div>

        <div class="p-3">
          <h3 class="text-center error-msg">{{ getLoginError }}</h3>
        </div>
      </form>
    </div>
    <div class="login-footer-flex">
      <div class="p-3">
        <div class="text-center">
          {{ getClient }}
        </div>
      </div>
    </div>
  </div>
</mat-sidenav-container>
